/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-01 10:06.
 */
const BaseCategoryPage = require( 'base/category-page' );
const Server = require( 'helper/server' );
const { initMenu } = require( 'purchasing-federation/common/config/member-center-menu' );

const listTpl = Handlebars.templates[ 'templates/member-roster-list' ];

class memberRoster extends BaseCategoryPage {
  constructor() {
    super( {
      events: {
        'click .js-status': 'statusChanged'
      }
    } );
    this.status = '';
    this.pageSize = 15;
  }

  async init() {
    // const data = initMenu( 'ActivityManage', {}, {} );
    // this.$el.find( '.list__nav-title' ).html( data.text );
    // this.$el.find( '.treeData[name="tree-data"]' ).html( JSON.stringify( data ) );
    super.init();
  }

  search() {
    const requestParams = {
      pageNo: this.pageNo,
      pageSize: this.pageSize
    };
    this.renderActivityList( requestParams );
  }

  statusChanged( e ) {
    const el = e.target || e.srcElement;
    const $el = $( el );
    if ($el.hasClass( 'selected' )) {
      return false;
    }
    const { status } = $el.data();
    this.status = status;
    $el.addClass( 'selected' ).siblings().removeClass( 'selected' );
    this.search();

  }

  async renderActivityList( requestParams ) {
    const { total = 0, data = [] } = await Server.queryMemberListApi( requestParams );
    const html = listTpl( {
      _DATA_: data,
      _TOTAL_: total,
      _pageSize_: this.pageSize
    } );
    this.$el.find( '.block__content' ).html( html );
    this.$el.find( '.block__content .total' ).text( total || 0 );
    this.initPagination( total || 0 );

  }
}

module.exports = memberRoster;
